import React, { useState } from "react";
import axios from "axios";

const API = "/api";

const statusColor = (status) => {
  const normalized = String(status || "pending").toLowerCase();
  if (normalized === "approved") return { background: "#dcfce7", color: "#166534", border: "#86efac" };
  if (normalized === "hold") return { background: "#fef3c7", color: "#92400e", border: "#fbbf24" };
  if (normalized === "rejected") return { background: "#fee2e2", color: "#991b1b", border: "#fca5a5" };
  return { background: "#e0f2fe", color: "#0369a1", border: "#7dd3fc" };
};

function FranchiseApplicationStatus() {
  const [applicationNo, setApplicationNo] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const checkStatus = async (event) => {
    event.preventDefault();
    setError("");
    setResult(null);

    if (!applicationNo.trim()) {
      setError("Please enter your application number.");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(`${API}/franchise-application-status`, {
        params: { application_no: applicationNo.trim(), _ts: Date.now() },
      });
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.message || "Application status could not be found.");
    } finally {
      setLoading(false);
    }
  };

  const badge = statusColor(result?.status);

  return (
    <main style={{ background: "radial-gradient(circle at top left, #dbeafe 0%, #f8fafc 42%, #fff7ed 100%)", minHeight: "70vh" }}>
      <section className="container py-5">
        <div
          style={{
            borderRadius: "28px",
            overflow: "hidden",
            background: "linear-gradient(135deg, #4e1b24 0%, #7c2d3a 50%, #c2410c 100%)",
            color: "#fff",
            padding: "34px",
            marginBottom: "24px",
          }}
        >
          <p className="text-uppercase fw-semibold mb-2" style={{ letterSpacing: "0.12em", opacity: 0.82 }}>Franchise Desk</p>
          <h1 className="fw-bold mb-2">Application Status</h1>
          <p className="mb-0" style={{ maxWidth: "760px", color: "rgba(255,255,255,0.82)", lineHeight: 1.8 }}>
            Enter the application number received after public franchise application submission and track your latest status.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-lg-5">
            <form onSubmit={checkStatus} className="bg-white border shadow-sm p-4" style={{ borderRadius: "18px" }}>
              <label className="form-label fw-semibold">Application No.</label>
              <input
                className="form-control form-control-lg"
                value={applicationNo}
                onChange={(event) => setApplicationNo(event.target.value)}
                placeholder="NIDCS-APP-YYYYMMDD-00000"
              />
              {error ? <div className="text-danger small mt-2">{error}</div> : null}
              <button className="btn btn-primary btn-lg w-100 mt-3" disabled={loading}>
                {loading ? "Checking..." : "Check Status"}
              </button>
            </form>
          </div>

          <div className="col-lg-7">
            <div className="bg-white border shadow-sm p-4 h-100" style={{ borderRadius: "18px" }}>
              {result ? (
                <>
                  <div className="d-flex justify-content-between gap-3 flex-wrap align-items-start">
                    <div>
                      <h4 className="fw-bold mb-1">{result.institute_name}</h4>
                      <p className="text-muted mb-0">{result.state_name || "-"} / {result.district_name || "-"}</p>
                    </div>
                    <span className="badge px-3 py-2" style={{ background: badge.background, color: badge.color, border: `1px solid ${badge.border}` }}>
                      {String(result.status || "pending").charAt(0).toUpperCase() + String(result.status || "pending").slice(1)}
                    </span>
                  </div>
                  <hr />
                  <div className="row g-3">
                    <div className="col-md-6"><strong>Application No:</strong><br />{result.application_no}</div>
                    <div className="col-md-6"><strong>Contact:</strong><br />{result.contact || "-"}</div>
                    <div className="col-md-6"><strong>Email:</strong><br />{result.email || "-"}</div>
                    <div className="col-md-6"><strong>Submitted:</strong><br />{result.created_at || "-"}</div>
                  </div>
                </>
              ) : (
                <div className="text-muted" style={{ lineHeight: 1.8 }}>
                  Your application details will appear here after entering a valid application number.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default FranchiseApplicationStatus;
